import { batch } from "react-redux";
import { CREATE_WINERY_BATCHES, DELETE_WINERY_BATCHES, ERROR_WINERY_BATCHES, IS_WINERY_BATCHES, LIST_OF_WINERY_BATCHES } from "../actions/types";

const initialState = {
    isLoadingWineryBatches: false,
    wineryBatchesList: [],
    hasMoreWineryBatches: true,
    skipWineryBatches: 0,

}

export default function (state = initialState, action) {
    switch (action.type) {
        case IS_WINERY_BATCHES:
            return { ...state, isLoadingWineryBatches: true }
        case "CLEAR_OF_WINERY_BATCHES":
            return { ...state, wineryBatchesList: [], isLoadingWineryBatches: false }



        case LIST_OF_WINERY_BATCHES:
            let idsWineryBatches = new Set(state.wineryBatchesList.map(wineryBatch => wineryBatch._id));
            let merge = [
                ...state.wineryBatchesList,
                ...action.payload.data.filter(wineryBatch => !idsWineryBatches.has(wineryBatch._id))
            ];
            return {
                ...state,
                hasMoreWineryBatches: action.payload.hasMore,
                wineryBatchesList: merge,
                isLoadingWineryBatches: false
            }

            // return { ...state, wineryBatchesList: { ...state.wineryBatchesList, batches: action.payload }, isLoadingWineryBatches: false }
        case CREATE_WINERY_BATCHES:

            var wineryBatchesList = Array.from(state.wineryBatchesList); 
            wineryBatchesList.push(action.payload)
            return { ...state, wineryBatchesList, isLoadingWineryBatches: false }
        case ERROR_WINERY_BATCHES:
            return { ...state, isLoadingWineryBatches: false }
        case DELETE_WINERY_BATCHES:
            const wineryBatchesListDelete = state.wineryBatchesList.map(batch => {
                if (batch._id ===action.payload.id) {
                    batch.quantityStock = batch.quantityStock - action.payload.quantityDeleted
                }
                return batch
            })
            return { ...state, isLoadingWineryBatches: false, wineryBatchesList: wineryBatchesListDelete }

        default:
            return state;
    }
}